module.exports = __webpack_public_path__ + "img/gittertraeger_new.65ab988f.svg";